module.exports = __webpack_public_path__ + "img/close.81173730.svg";